'use client';

import type { ImageProps } from 'next/image';
import { CustomImage } from 'components/shared/custom-image';

/**
 * CustomImage behind a client boundary. CustomImage hands next/image a loader
 * function for CDN srcs, which a Server Component can't pass to the client, so
 * the gifting server sections render this instead.
 */
export const GiftingImage = (props: ImageProps) => <CustomImage {...props} />;
